(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observers = new WeakMap();
    const connectHeroes = () => {
      document.querySelectorAll('.sm-home-hero[data-fit-first-screen="true"]').forEach((hero) => {
        observers.get(hero)?.disconnect();
        const header = document.getElementById('header');
        const section = hero.closest('.shopify-section');
        const banner = section?.nextElementSibling?.querySelector('.sm-home-banner');
        const measure = () => {
          if (header) hero.style.setProperty('--sm-measured-header', `${header.getBoundingClientRect().height}px`);
          hero.style.setProperty('--sm-measured-banner', `${banner?.getBoundingClientRect().height || 0}px`);
        };
        const observer = new ResizeObserver(measure);
        observers.set(hero, observer);
        if (header) observer.observe(header);
        if (banner) observer.observe(banner);
        measure();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectHeroes);
    else connectHeroes();
    document.addEventListener('shopify:section:load', connectHeroes);
    document.addEventListener('shopify:section:reorder', connectHeroes);
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.sm-home-hero').forEach((hero) => observers.get(hero)?.disconnect());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
